import React from 'react';
import { LoadingMessageContainer } from './LoadingMessage.styles';
import { AllieImg, AllieText } from '../../../components';

interface AllieLoadingMessageProps {
  title: string;
  isMobile?: boolean;
}

const namespace = 'loading-message';

export const AllieLoadingMessage: React.FC<AllieLoadingMessageProps> = ({
  title,
  isMobile,
}) => {
  return (
    <LoadingMessageContainer isMobile={isMobile}>
      <AllieText type="h3">{title}</AllieText>
      <div className={`${namespace}-gif`}>
        <AllieImg src="assets/loading.gif" />
      </div>
    </LoadingMessageContainer>
  );
};
